export default {
    categories: {
        'product-price': {
            title: window.i18n.__('Produits'),
            subtitle: window.i18n.__('Catégories tarifaire'),
        },
    },
    rows: [
        {
            category: 'product-price',
            label: window.i18n.__('Identifiant produit'),
            description: {
                text: window.i18n.__('Récupéré depuis un export produits Sellsy'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison.'),
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product-price',
            label: window.i18n.__('Référence produit'),
            description: {
                text: window.i18n.__('Référence ou code du produit unique sur lequel la catégorie tarifaire sera mise à jour'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison.'),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'product-price',
            label: window.i18n.__('Identifiant déclinaison'),
            description: {
                text: window.i18n.__('Récupéré depuis un export de déclinaisons produit Sellsy'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison.'),
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'product-price',
            label: window.i18n.__('Référence déclinaison'),
            description: {
                text: window.i18n.__('Référence ou code de la déclinaison produit unique sur lequel la catégorie tarifaire sera mise à jour'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison.'),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
    ],
};
